import { createSharedComposable } from '@vueuse/core'
import type { CombinedJackpotWebsocketResponse, CombinedJackpotWebsocket } from '@game/types'
import { ref, useXmppListener } from '#imports'

export const useGamesJackpotsSubsriber = createSharedComposable(() => {
    const jackpots = ref<Record<string, number>>({})

    if (import.meta.client) {
        useXmppListener({ kind: 'message', xmlns: 'cego:JackpotsUpdated' }, (result: CombinedJackpotWebsocketResponse) => {
            if (!result?.games?.length) return

            for (const jackpotGame of result.games as Array<CombinedJackpotWebsocket>) {
                jackpots.value[jackpotGame.slug] = Number.parseFloat(jackpotGame.jackpot)
            }
        })
    }

    return {
        jackpots,
    }
})
